import styled from 'styled-components';
import { TABLET_WIDTH } from 'constants/breakPoints';
import { black, orange } from 'constants/colors';
import { RalewayFont } from 'constants/fonts';

export const ThemeTableDetailWrapper = styled.div`
  @media (max-width: ${TABLET_WIDTH}px) {
    padding-bottom: 8rem;
  }
  > .header {
    padding: 2rem 2rem;
    height: 7rem;
    box-shadow: inset 0px -2px 4px -2px rgba(0, 0, 0, 0.16);
    display: flex;
    .back_button {
      cursor: pointer;
      margin-right: 1.5rem;
      flex: 1;
      i {
        color: ${black};
        font-size: 1.8rem;
      }
    }

    > div {
      display: inline-block;
      vertical-align: middle;
    }

    > .title {
      color: ${black};
      font-size: 1.8rem;
      margin-right: 2rem;
      flex: 100;
      font-family: ${RalewayFont.regularFamily};
      img {
        margin-right: 0.5rem;
      }
    }


    @media (max-width: ${TABLET_WIDTH}px) {
      .btn_join_lg {
        display: none;
      }

      .title {
        width: calc(100% - 5rem);
      }


    }
  }

  .expand {
    display: inline-block;
    background-color: #2680EB;
    height: 6rem;
    float: right;
    padding: 1rem;
    text-align: center;
    font-size: 1.5rem;
    cursor: pointer;

    img {
      transform: rotateY(180deg);
    }

    p {
      color: white;
      font-weight: 600;
    }
  }

  .no_elements {
    > div {
      color: ${black};
    }
  }

  .tabs {
    background-color: #fff;

    @media (max-width: ${TABLET_WIDTH}px) {
      position: sticky;
      top: 0rem;
      border-bottom: 1px solid #eee;
      z-index: 10;
    }
  }

  .tabs::-webkit-scrollbar {
    display: none;
  }

  .table_content {
    &.with_chat {
      display: grid;

      .tab_content {
        height: calc(100vh - 10rem);
        overflow: auto;
      }
    }
    @media (min-width: ${TABLET_WIDTH}px) {
      .chat_container {
        height: calc(100vh - 14.3rem);

        .list_messages {
          height: calc(100vh - 14.3rem);
        }
      }
    }

    .chat_lateral {
      box-shadow: rgb(0 0 0 / 16%) 0px 3px 6px;
      height: calc(100vh - 5rem);

      .chat_title {
        background-color: ${props => props.color};
        color: #fff;
        height: 6.4rem;
        font-size: 1.6rem;
        padding: 2.5rem 1rem 0;
      }

      .chat_container {
        height: calc(100vh - 15.4rem);

        .list_messages {
          height: calc(100vh - 15.4rem);
        }
      }
    }
  }
`;

export const TitleBack = styled.div`
  .title_create {
    margin: 1% 0;
    text-align: left;

    div {
      display: inline-block;
      font-family: ${RalewayFont.regularFamily};
      font-size: 22px;
      margin: 1%;
    }

    img {
      display: inline-block;
      margin-left: 1%;
      cursor: pointer;
    }
`;

export const DescriptionTab = styled.div`
  .callInfo {
    height: 15rem;
    width: 100%;
    display: flex;
    align-items: center;
    

    .back {
      height: 70%;
      width: 4%;
      display: flex;
      justify-content: flex-end;
      i {
        font-size: 2rem;
        cursor: pointer;
      }
    }
    img {
      height: 80%;
      width: 20%;
    }
    .data {
      height: 70%;
      width: 40%;
      .name {
        font-size: 1.8rem;
        font-weight: 800;
        margin: 1rem;
      }
      .live_event {
        font-size: 1.4rem;
        margin: 1rem;
      }
      .starting {
        font-size: 1.4rem;
        margin: 1rem;
        display: flex;
        align-items: center;
      }
    }
    .buttons {
      height: 80%;
      width: 31%;
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      .main_button {
        width: 10rem;
        font-size: 1.2rem;
        background: #2680EB;
        color: white;
        padding: 1rem;
        margin: 1rem;
        border-radius: 2rem;
        text-transform: uppercase;
      }
      .sec_button {
        width: 10rem;
        font-size: 1.2rem;
        border: 0.1rem solid #2680EB;
        color: #2680EB;
        padding: 1rem;
        margin: 1rem;
        border-radius: 2rem;
        text-transform: uppercase;
      }
    }
    @media (max-width: ${TABLET_WIDTH}px) {
      height: 12rem;
      position: relative;
      .back {
        display: none;
      }
      img {
        height: 80%;
        width: 30%;
      }
      .data {
        height: 70%;
        width: 70%;
        .name {
          font-size: 1.2rem;
        }
        .live_event {
          font-size: 1rem;
        }
        .starting {
          font-size: 1rem;
        }
      }
      .buttons {
        height: 80%;
        width: 50%;
        display: flex;
        flex-direction: row;
        position: absolute;
        bottom: 0;
        right: 0;
        .main_button {
          width: 7rem;
          font-size: 0.9rem;
          font-weight: bold;
          background: #2680EB;
          color: white;
          padding: 0.5rem;
          margin: 1rem;
          border-radius: 2rem;
          box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
          text-transform: none;
        }
        .sec_button {
          width: 7rem;
          font-size: 0.9rem;
          font-weight: bold;
          border: none;
          background: white;
          color: #2680EB;
          padding: 0.5rem;
          margin: 1rem;
          border-radius: 2rem;
          box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
          text-transform: none;
        }
      }
    }
  }
  > .header {
    height: 15rem;
    background-color: #fff;
    background-image: url(${props => props.image});
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    position: relative;
    color: ${black};
    display: flex;

    @media (max-width: ${TABLET_WIDTH}px) {
      height: 12rem;
    }

    .curtain {
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
      color: #fff;
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 26%;
      @media (max-width: ${TABLET_WIDTH}px) {
          width: 45%;
        }
      .table_card {
        padding-top: 6rem;
        transform: scale(0.7);
        @media (max-width: ${TABLET_WIDTH}px) {
          transform: scale(0.5);
        }
      }
    }

    .data {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: -1rem;
      @media (max-width: ${TABLET_WIDTH}px) {
        margin-left: -5rem;
      }
      .name {
        margin: 0.5rem;
        color: white;
        z-index: 2;
        font-size: 1.8rem;
        font-weight: 800;
        @media (max-width: ${TABLET_WIDTH}px) {
          font-size: 1.2rem;
        }
      }
      .countdown {
        margin: 0.5rem;
        color: white;
        z-index: 2;
        font-size: 1.4rem;
        font-weight: 800;
        display: flex;
        align-items: center;
        @media (max-width: ${TABLET_WIDTH}px) {
          font-size: 1rem;
        }
      }
      .data_buttons {
        width: 90%;
        z-index: 4;
        margin: 0.5rem;
        display: flex;
        justify-content: flex-end;
        @media (max-width: ${TABLET_WIDTH}px) {
          display: none;
        }
        .boost {
          background: #2680EB;
          color: white;
          font-size: 1.4rem;
          padding: 1rem 4rem;
          border-radius: 2rem;
        }
        .launch{
          border: 0.1rem #2680EB solid;
          color: #2680EB;
          background: white;
          font-size: 1.4rem;
          padding: 1rem 3rem;
          border-radius: 2rem;
        }
      }
    }

    .buttons {
      width: 33%;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding: 2rem;
      justify-content: center;
      .top_buttons {
        margin: 0.5rem;
      }
      .rounded {
        background: white;
        padding: 0.6rem 0.8rem;
        border-radius: 100%;
        img {
          width: 2rem;
          height: 2rem;
        }
      }
      .bottom_buttons {
        display: flex;
        flex-direction: column;
        justify-content: center;
        @media (max-width: ${TABLET_WIDTH}px) {
          display: none;
        }
      }
      .kill {
        font-size: 1.4rem;
        color: black;
        padding: 1rem 2rem;
        background: #D0D0D4;
        border-radius: 2rem;
        margin: 0.5rem;
      }
      .guided {
        font-size: 1.4rem;
        color: #2680EB;
        padding: 1rem 2rem;
        background: white;
        border-radius: 2rem;
        margin: 0.5rem;
      }
    }
    @media (max-width: ${TABLET_WIDTH}px) {
      .buttons {
        .top_buttons {
          display: flex;
        }
        .rounded {
          display: none;
        }
        .phone_rounded {
          background: white;
          padding: 0.6rem 0.8rem;
          border-radius: 100%;
          margin: 0.5rem;
          .share {
            height: 2rem;
          }
          .dots {
            height: 2rem;
            width: 2rem;
          }
        }
      }
    }
    @media (min-width: ${TABLET_WIDTH}px) {
      .buttons {
        .phone_rounded {
          display: none;
        }
      }
    }
  }

  .grid_info {
    margin: 2rem 2rem 4rem;
    color: #707070;

    .description {
      font-size: 1.4rem;
      line-height: 1.8rem;
      margin-bottom: 2rem;
    }

    @media (max-width: ${TABLET_WIDTH}px) {
      grid-template-columns: 1fr;
    }
  }

  .name_section {
    color: #333;
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-family: ${RalewayFont.regularFamily};
    display: flex;
    align-items: center;
    .number {
      font-weight: bold;
      color: black;
      margin-right: 0.5rem;
    }
    .invite_placeholder{
      font-size: 1.2rem;
      margin-left: 0.8rem;
      color: #2680EB;
    }
  }

  .lists {
    margin: 0 2rem 2rem;

    @media (max-width: ${TABLET_WIDTH}px) {
      margin: 0 0rem 2rem;

      .title_section {
        margin-left: 2rem;
      }

      .simple_carousel  {
        > div:first-child {
          margin-left: 2rem;
        }
      }
    }

    .list {
      margin-bottom: 2rem;

      .header_list {
        display: grid;
        grid-template-columns: auto 50px;
        grid-gap: 2rem;

        .icon_expand {
          justify-self: end;
          img {
            cursor: pointer;
            height: 20px;
          }
        }
      }

      .face_bubble {
        cursor: pointer;
        margin: 0 1rem;
      }

      .face_bubble_text {
        color: ${black};
      }

      .bubbles {
        &.in_line {
          .faces_wrapper {
            white-space: nowrap;
            overflow: auto;
            text-align: left;
          }
        }

        &.in_table {
          .face_bubble {
            width: calc(100% / 4);
          }
        }
      }
    }

    @media (max-width: ${TABLET_WIDTH}px) {
      grid-template-columns: 100%;
      width: 100%;
    }
  }

  .btn_join_sm {
    margin-bottom: 4rem !important;
    @media (min-width: ${TABLET_WIDTH}px) {
      display: none;
    }
  }
  .users {
    display: flex;
    flex-wrap: wrap;
  }

  .leaveTable{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2rem;
  }
`;

export const FeedbackModal = styled.div`
    width: 69rem;
    max-width: 100%;
    position: absolute;
    border-radius: 2rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    outline: none;
    height: 95%;
`;

export const DocIframe = styled.iframe`
  width: ${props => props.width};
  height: ${props => props.height};
  margin-top: 1rem;
  border-radius: 2rem;
  border: 0px;
  background-color: #fff;

  @media (max-width: ${TABLET_WIDTH}px) {
    height: ${props => props.height};
  }
`;

export const JoinModal = styled.div`
    width: 69rem;
    max-width: 100%;
    position: absolute;
    border-radius: 2rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    outline: none;
    height: 95%;
    background-color: #fff;
    padding: 2rem;
`;

export const LeaveTable = styled.div`
  background-color: #F44336;
  font-size: 1.4rem;
  padding: 1rem;
  font-weight: bold;
  padding: 1rem;
  border-radius: 20px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const BtnShare = styled.div`
  flex: 1;
  i {
    font-size: 1.8rem;
    color: black;
    cursor: pointer;
  }
`;

export const BoostModal = styled.div`
  width: 33rem;
  position: fixed;
  left: 5%;
  background: white;
  border-radius: 1.5rem;
  top: 20%;
  z-index: 10;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  flex-direction: column;
  display: flex;
  align-items: center;
  .close_button {
    width: 90%;
    height: 5%;
    font-size: 2rem;
    margin-top: 2rem;
    i {
      float: right;
    }
  }
`;

export const BoostTitle = styled.div`
  margin-top: 2rem;
  font-size: 1.8rem;
  width: 80%;
`;

export const BoostSubtitle = styled.div`
  margin-top: 1rem;
  font-size: 1.2rem;
  width: 80%;
`;

export const BoostNextButton = styled.div`
  color: white;
  margin-top: 2rem;
  text-align: center;
  font-size: 1.2rem;
  width: 7rem;
  padding: 0.8rem;
  cursor: pointer;
  border-radius: 2rem;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  font-weight: bold;
  background: ${props => (props.cont ? '#2680EB' : 'gray')};
  margin-bottom: 2rem;
`;

export const BoostInputText = styled.input`
  margin: 2rem;
  height: 6rem;
  width: 85%;
  border: none;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  border-radius: 1rem;
  outline: none;
  padding: 1rem;
  font-size: 1.4rem;
  color: #2680EB;
`;

export const BoostUrgency = styled.div`
  margin: 1rem;
  display: flex;
  width: 85%;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
`;

export const BoostUrgencyTime = styled.div`
  border: 0.1rem solid black;
  border-radius: 1rem;
  padding: 1rem;
  font-size: 1.1rem;
  margin: 0.4rem;
  color: ${props => (props.sel ? 'white' : 'black')};
  background: ${props => (props.sel ? '#2680EB' : '')};
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .list {
    width: 90%;
    margin-top: 1rem;
    .header_list {
      display: grid;
      grid-template-columns: auto 50px;
      grid-gap: 2rem;

      .icon_expand {
        justify-self: end;
      img {
        cursor: pointer;
        height: 20px;
      }
    }
  }
  }
  .name_section {
    color: #333;
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-family: ${RalewayFont.regularFamily};
    display: flex;
    align-items: center;
    .number {
      font-weight: bold;
      color: black;
      margin-right: 0.5rem;
    }
    .invite_placeholder{
      font-size: 1.2rem;
      margin-left: 0.8rem;
      color: #2680EB;
    }
  }
  .container_doc {
    width: 100%,
    height: 100%;
  }
`;

export const ButtonAttach = styled.button`
  background: ${props => (!props.selected ? 'white' : '#2680EB')};
  background: ${props => props.back};
  color: ${props => (!props.selected ? 'gray' : 'white')};
  color: ${props => props.color};
  width: 33rem;
  height: 4rem;
  border-radius: 2rem;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: ${props => props.margin};
  i {
    position: absolute;
    left: 2rem;
    font-size: 1.8rem;
  }
`;

export const ContentTypes = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .text {
    font-size: 1.4rem;
    color: gray;
    margin: 1rem;
  }
  input {
    width: 30rem;
    height: 5rem;
    border: none;
    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
    border-radius: 1rem;
    margin: 1rem;
    padding: 2rem;
    font-size: 1.3rem;
  }
  .input {
    width: 30rem;
    height: 5rem;
    border: none;
    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
    border-radius: 1rem;
    margin: 1rem;
    padding: 2rem;
    font-size: 1.3rem;
    position: relative;
    display: flex;
    align-items: center;
    i {
      font-size: 1.8rem;
      position: absolute;
      right: 2rem;
    }
  }
`;

export const OptionsModal = styled.div`
  position: absolute;
  right: 18%;
  top: 70%;
  width: 13rem;
  background: white;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  border-radius: 2rem;
  padding: 1rem;
  button {
    margin: 0.5rem;
    width: calc(100% - 1rem);
    font-size: 1rem;
    font-weight: bold;
    padding: 0.6rem;
    border-radius: 2rem;
    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  }

  .edit {
    background: #2680EB;
    color: white;
  }
  .boost {
    background: #2680EB;
    color: white;
  }
  .launch {
    background: white;
    color: #2680EB;
  }
  .killButton {
    background: #DBDBDB;
  }
  .delete {
    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
    color: #F63256;
  }
`;

export const MinimizeCarousel = styled.div`
    height: 6rem;
    overflow: hidden;
    position: relative;
    transition: all 0.3s ease;

    .opacity_gradient {
      background: linear-gradient(180deg, rgba(255,255,255,0.5) 0%, rgba(20,20,20,0.5) 100%);
      position: absolute;
      z-index: 1;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      color: #fff;
      text-align: center;
      font-size: 1.8rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: ${RalewayFont.boldFamily};
      cursor: pointer;
  }

  &.show_all {
    height: 25rem;
    .opacity_gradient {
      display: none;
    }
  }
`;

export const ChatTab = styled.div`
  .chat_header {
    display: none;
  }

  @media (max-width: ${TABLET_WIDTH}px) {
    .chat_wrapper {
      top: calc(10rem + env(safe-area-inset-top));
    }

    .chat_container {
      height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));

      .list_messages {
        height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));
      }
    }
  }
`;

export const JoinTable = styled.div`
  position: fixed;
  z-index: 3;
  background: rgb(0,0,0,0.5);
  width: 100%;
  height: 100%;
  top: 20rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  @media (max-width: ${TABLET_WIDTH}px) {
    top: 17rem;
  }
`;

export const AddButton = styled.div`
  background: #2680EB;
  border-radius: 100%;
  font-size: 4rem;
  color: white;
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  padding: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CreateTable = styled.div`
  position: relative;
  top: 44rem;
  right: 4rem;
  float: right;
  z-index: 10000000000000;

  @media (max-width: ${TABLET_WIDTH}px) {
    bottom: 8rem;
    right: 2rem;
    top: auto;
    position: fixed;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ThemeTableDetail/components/styles.js